
import { Tag } from "antd" 
import { BiPackage } from "react-icons/bi";
import { BsBoxes } from "react-icons/bs";
import { FaBottleDroplet, FaBoxesPacking,FaCubesStacked } from "react-icons/fa6"; 
import {DropboxOutlined} from "@ant-design/icons";

function TagDocRuncode({result = ""}) {
  let elementToRender;

  // let value = 'green';
  //   if( props.data === 'Finish Goods' ) value = 'green'
  //   else if( props.data === 'Ingredients' ) value = 'geekblue'
  //   else if( props.data === 'Packing Goods' ) value = 'blue'
  //   else if( props.data === 'Raw Material' ) value = 'red'
  //   else if( props.data === 'Packing' ) value = 'purple'
  //   else if( props.data === 'Packaging' ) value = 'orange'
  //   else value = 'volcano'

  switch (result?.toLowerCase()) {
    case 'pk':
      elementToRender = <Tag icon={<FaBottleDroplet />} color="orange" className='flex gap-2 justify-center items-center' > Packaging </Tag>;
      break;
    case 'pc':
      elementToRender = <Tag icon={<DropboxOutlined />} color="purple" className='flex gap-2 justify-center items-center' > Packing </Tag>;
      break;
      case 'fg':
      elementToRender = <Tag icon={<BsBoxes />} color="green" className='flex gap-2 justify-center items-center' > Finished Goods </Tag>;
      break;
      case 'pg':
      elementToRender = <Tag icon={<BiPackage />} color="blue" className='flex gap-2 justify-center items-center' > Packing Goods </Tag>;
      break;
      case 'wi':
      elementToRender = <Tag icon={<FaCubesStacked />} color="gold" className='flex gap-2 justify-center items-center' > Work Instruction</Tag>;      
      break;
      case 'ig':
      elementToRender = <Tag icon={<DropboxOutlined />} color="geekblue" className='flex gap-2 justify-center items-center' > Ingredient </Tag>;
      break;
      case 'rm':
      elementToRender = <Tag icon={<FaBoxesPacking />} color="red" className='flex gap-2 justify-center items-center' > Raw Material </Tag>;
      break;
    default:
      elementToRender = <Tag  className='flex gap-2 justify-center items-center' > Not found </Tag>;
  }
  return <>{elementToRender}</>
}

export default TagDocRuncode